import React, { useState, useRef, useEffect, memo } from "react";
import Modal from 'react-bootstrap/Modal';
import { Document, Page, pdfjs } from 'react-pdf';
import 'pdfjs-dist/web/pdf_viewer.css';
import CustomButton from "../../Utils/CustomButton";
import getApiCall from "../../Services/getApiCall";
import { toast } from "react-toastify";
import moment from "moment";
import postApiCall from "../../Services/postApiCall";

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.mjs`;



const ESignReportModal = ({
  show,
  onHide,
  reportURL,
  templateDetail,
  getList,
  responseData,
  isNpaReport,
  formName
}) => {
  const containerRef = useRef(null);
  console.log("zzz111 reportURL in ESignReportModal = ", reportURL);
  const [numPages, setNumPages] = useState(0);
  const [width, setWidth] = useState(800);
  const [isSigned, setIsSigned] = useState(false);


  useEffect(() => {
    const updateWidth = () => {
      if (containerRef.current) {
        setWidth(containerRef.current.offsetWidth);
      }
    };

    updateWidth();
    window.addEventListener("resize", updateWidth);

    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  const downloadPdf = () => {
    const blob = reportURL; // your response.data stored as Blob

    //   const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blob;
    link.download = isNpaReport?`${responseData.formFields.prospectNo}-${moment().format('DD-MM-YYYY')}-${responseData.formFields.vendorCode}.pdf`:`${formName+'-'+moment(new Date()).format('DD-MM-YYYY')}.pdf`;

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);

    window.URL.revokeObjectURL(blob);
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "/assets/js/leegalityv8.js";
    script.async = true;

    script.onload = () => {
      console.log("Leegality SDK Loaded");
      console.log("SDK =", window.LeegalitySDK);

      console.log(window.LeegalitySDK);
    };

    document.body.appendChild(script);
  }, []);

  const callbackEsign = (response) => {
    console.log("ESign Response:", response);

    if (response?.error) {
      toast.error("Error: " + response.error);
      return;
    }

    // success
    addLeegalityDoc(response);
    // alert("Success: " + response.message);
  };

  const addLeegalityDoc = async (response) => {
    try {
      const obj = {
        formId: templateDetail?.formId,
        responseId: templateDetail?.responseId,
        leegalityDocumentId: response.documentId
      };

      const res = await postApiCall("common/leegality/admin/update-status", obj);

      if (res.meta.status) {
        toast.success(res.meta.msg);
        setIsSigned(true)
        onHide()
        getList(); // Call getList to refresh the table
      } else {
        toast.error(res.meta.msg);
      }

    } catch (err) {
      console.error(err);
    }
  };

  const handleESign = async () => {
    try {
      const response = await getApiCall(`admin/submit/form/download/docs/pdf/${templateDetail?.formId}/null/${templateDetail?.responseId}?eSign=true`)

      if (response.meta.status) {
        const url = response.data
        console.log("zzz111 url for legality = ", url);
        // setLegalityUrl(response.data.signUrl)
        //    window.location.href = response.data.signUrl;
        if (!window.Leegality) {
          alert("Leegality SDK not loaded");
          return;
        }

        const obj = {
          logoUrl: "",
          callback: callbackEsign,
        };

        const leegality = new window.Leegality(obj);

        leegality.init();

        leegality.esign(response.data.signUrl);
      }
      else{
        toast.error(response.meta.msg)
      }
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <Modal show={show} onHide={onHide} size="lg" centered 
    scrollable
  backdrop="static"
  keyboard={false}
    >
      <Modal.Header className="align-items-center">
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <Modal.Title>E-Sign Report</Modal.Title>
        </div>
        <i
          className="fa fa-times ms-auto"
          role="button"
          onClick={onHide}
          style={{ fontSize: '1.2rem', cursor: 'pointer' }}
        />
      </Modal.Header>
      <Modal.Body>
        <div ref={containerRef} style={{overflowX:'hidden'}}>

          {

            reportURL?.trim() ? (
              <Document
                file={reportURL}
                onLoadSuccess={({ numPages }) => {
                  console.log("Pages:", numPages);
                  setNumPages(numPages);
                }}
                onLoadError={(error) => {
                  console.error("PDF Load Error", error);
                }}
              >
                {Array.from({ length: numPages }, (_, index) => (
                  <Page
                    key={index}
                    pageNumber={index + 1}
                    width={width}
                  />
                ))}
              </Document>

            ) : (
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '70vh',         // Full viewport height
                fontSize: '20px',
                color: '#888',
                textAlign: 'center'
              }}>
                📄 No document found or invalid file URL.
              </div>
            )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-end">
          <CustomButton label={'Download Report'} appendClass="text-white" variant="secondary" onClick={downloadPdf} />
          {!isSigned && (
            <CustomButton label={'E-Sign'} appendClass="text-white" variant="secondary" onClick={handleESign} />
          )}
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default memo(ESignReportModal);